// Mock data for FlowAI landing page
export const mockData = {
  hero: {
    title: "Automate Workflows. Accelerate Growth.",
    subtitle: "FlowAI helps startups streamline operations with powerful AI-driven tools.",
    dashboardImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxhbmFseXRpY3MlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzU4NzUwNDA5fDA&ixlib=rb-4.1.0&q=85",
    mobileImage: "https://images.unsplash.com/photo-1640694514279-090bb1b09ee9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2JpbGUlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzU4NzUwNDE0fDA&ixlib=rb-4.1.0&q=85"
  },
  
  features: [
    {
      id: 1,
      title: "Seamless Automation",
      description: "Save time with built-in smart workflows that adapt to your business needs.",
      icon: "Zap"
    },
    {
      id: 2,
      title: "Team Collaboration",
      description: "Keep projects aligned in one platform with real-time updates and notifications.",
      icon: "Users"
    },
    {
      id: 3,
      title: "Analytics Dashboard",
      description: "Make data-driven decisions with real-time insights and comprehensive reporting.",
      icon: "BarChart"
    },
    {
      id: 4,
      title: "Secure & Scalable",
      description: "Enterprise-grade security and flexibility that grows with your business.",
      icon: "Shield"
    }
  ],

  howItWorks: [
    {
      step: 1,
      title: "Sign up in minutes",
      description: "Create your account and set up your workspace in under 5 minutes."
    },
    {
      step: 2,
      title: "Connect your tools",
      description: "Integrate with your existing tools and platforms seamlessly."
    },
    {
      step: 3,
      title: "Watch workflows run automatically",
      description: "Sit back as FlowAI automates your processes and saves you time."
    }
  ],

  pricing: [
    {
      id: 1,
      name: "Starter",
      price: "€29",
      period: "/mo",
      description: "For freelancers & small teams",
      popular: false,
      features: [
        "Up to 5 team members",
        "10 automated workflows",
        "Basic analytics",
        "Email support",
        "Standard integrations"
      ]
    },
    {
      id: 2,
      name: "Growth",
      price: "€79",
      period: "/mo",
      description: "For scaling startups",
      popular: true,
      features: [
        "Up to 25 team members",
        "Unlimited workflows",
        "Advanced analytics",
        "Priority support",
        "All integrations",
        "Custom dashboards"
      ]
    },
    {
      id: 3,
      name: "Enterprise",
      price: "Custom",
      period: "",
      description: "For large organizations needing advanced features",
      popular: false,
      features: [
        "Unlimited team members",
        "Enterprise workflows",
        "Custom reporting",
        "Dedicated support",
        "On-premise deployment",
        "SLA guarantee"
      ]
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "CEO, TechStart",
      image: "https://images.unsplash.com/photo-1657128344786-360c3f8e57e5",
      quote: "FlowAI cut our onboarding time in half. We scaled faster than ever."
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "CTO, InnovateLab",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a",
      quote: "The automation capabilities are incredible. Our team productivity increased by 200%."
    },
    {
      id: 3,
      name: "David Williams",
      role: "Founder, GrowthCo",
      image: "https://images.unsplash.com/photo-1629425733761-caae3b5f2e50",
      quote: "FlowAI simplified our complex workflows. Now we focus on what matters most."
    }
  ],

  backgroundImages: {
    techAbstract: "https://images.unsplash.com/photo-1758657286956-f944e1d2e75a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHRlY2glMjBnZW9tZXRyaWN8ZW58MHx8fHwxNzU4NzUwNDY2fDA&ixlib=rb-4.1.0&q=85",
    geometricBlue: "https://images.unsplash.com/photo-1605106702734-205df224ecce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxnZW9tZXRyaWMlMjBiYWNrZ3JvdW5kc3xlbnwwfHx8fDE3NTg3NTA0NzF8MA&ixlib=rb-4.1.0&q=85",
    abstractGeometric: "https://images.unsplash.com/photo-1524168948265-8f79ad8d4e33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxnZW9tZXRyaWMlMjBiYWNrZ3JvdW5kc3xlbnwwfHx8fDE3NTg3NTA0NzJ8MA&ixlib=rb-4.1.0&q=85"
  }
};